export { default } from './CicSectionCard';
